module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/object/set-prototype-of.js
// module id = 249
// module chunks = 168707334958949